import { FC } from "react";
import { Text, Line, Circle } from "react-konva";
import houseModelConfig from "utils/houseModelConfig";
import paperSize from "utils/paperSize";

type TThirdGoalsProps = {
  text?: string;
};

const fontSize = houseModelConfig.fontSize;
const lineHeight = houseModelConfig.lineHeight;
const textColor = houseModelConfig.colorGlobals[2];
const guildeCircleSize = 2;
const guildeLineColor = houseModelConfig.colorGlobals[2];
const x = paperSize.width - paperSize.width / 6;
const y = (paperSize.height * 35) / 100;
const w = paperSize.width / 6;
const h = fontSize * lineHeight * 13;
const guildePoints = [
  (paperSize.width * 55) / 100,
  (paperSize.height * 57) / 100,
  x - 50,
  y + fontSize / 2,
  x - 20,
  y + fontSize / 2,
];

const ThirdGoals: FC<TThirdGoalsProps> = ({ text }) => {
  if (!text) {
    return null;
  }

  return (
    <>
      <Circle
        x={guildePoints[0]}
        y={guildePoints[1]}
        radius={guildeCircleSize}
        fill={guildeLineColor}
      />
      <Circle
        x={guildePoints[4]}
        y={guildePoints[5]}
        radius={guildeCircleSize}
        fill={guildeLineColor}
      />
      <Line
        points={guildePoints}
        stroke={guildeLineColor}
        strokeWidth={1}
        lineJoin="round"
        dash={[3, 2]}
      />
      <Text
        x={x - 10}
        y={y}
        width={w}
        height={h}
        fontSize={fontSize}
        lineHeight={lineHeight}
        text={text}
        fill={textColor}
      />
    </>
  );
};

export default ThirdGoals;
